import { Avatar, Box, Flex, Text } from '@chakra-ui/react'
import { FaFilePdf, FaHistory, FaRegTrashAlt } from 'react-icons/fa'
import { FaRegPaperPlane } from 'react-icons/fa6'
import { MdOutlineOpenInNew } from 'react-icons/md'
import { ButtonCmp } from '../../../../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../../../../components/ElementoTooltipCmp'
import { iAssinates } from '../../../../../../../interfaces'
import { formatarDataHora } from '../../../../../utils/data'
import { configPorStatus, TagStatus } from '../../../TagStatus'
import { iEntradaHistorico } from '../..'
import { HistoricoAjustes } from '../HistoricoAjustes'

interface iProps {
  assinante: iAssinates
  status: number
  dataInteracao?: string
  tokenExpirado: boolean
  historico: iEntradaHistorico[]
  ultimaEntrada?: iEntradaHistorico
  historicoAberto: boolean
  onAlternarHistorico: () => void
  onAbrirSolicitacao: (entrada: iEntradaHistorico) => void
  onReenviar: () => void
  onExcluir: () => void
  onBaixarPdf: () => void
  baixandoPdf: boolean
}

export const CardAssinante: React.FC<iProps> = ({
  assinante,
  status,
  dataInteracao,
  tokenExpirado,
  historico,
  ultimaEntrada,
  historicoAberto,
  onAlternarHistorico,
  onAbrirSolicitacao,
  onReenviar,
  onExcluir,
  onBaixarPdf,
  baixandoPdf
}) => {
  const config = configPorStatus[status] ?? configPorStatus[0]
  const data = formatarDataHora(dataInteracao)
  const temHistorico = historico.length > 0
  // Em solicitacao aberta a ultima ja abre pelo "Ver solicitacoes", entao o historico so soma se houver mais de uma
  const mostrarHistorico = temHistorico && (status !== 1 || historico.length > 1)

  return (
    <Box position={'relative'} pl={'2rem'}>
      <Box
        position={'absolute'}
        left={'-11px'}
        top={'1.125rem'}
        w={'20px'}
        h={'20px'}
        borderRadius={'50%'}
        border={'4px solid white'}
        bgColor={config.solida}
      />

      <Box
        bgColor={'white'}
        border={'1px solid var(--Gray5)'}
        borderRadius={'.375rem'}
        boxShadow={'var(--SombraBackground)'}
        overflow={'hidden'}
      >
        <Flex p={'1rem'} justifyContent={'space-between'} gap={'1rem'} flexWrap={'wrap'}>
          <Flex gap={'.75rem'} alignItems={'flex-start'}>
            <Avatar name={assinante.nome} src={assinante.avatar} h={'40px'} w={'40px'} />
            <Box>
              <Text fontSize={'15px'} fontWeight={'500'} color={'var(--Gray1)'}>{assinante.nome}</Text>
              <Text fontSize={'13px'} color={'var(--Gray3)'}>{assinante.email}</Text>
              <Text fontSize={'12px'} color={'var(--Gray4)'} mt={'.125rem'}>
                {data ?? 'Aguardando ação'}
              </Text>
            </Box>
          </Flex>

          <Flex flexDir={'column'} alignItems={'flex-end'} gap={'.625rem'}>
            <Flex alignItems={'center'} gap={'.5rem'}>
              {tokenExpirado && status !== 2 && (
                <Text fontSize={'12px'} color={'var(--Red)'}>Token expirado</Text>
              )}
              <TagStatus status={status} />
            </Flex>

            <Flex gap={'.5rem'} flexWrap={'wrap'} justifyContent={'flex-end'}>
              {status === 1 && ultimaEntrada && (
                <ButtonCmp
                  small
                  OutlineColor={'OrangeEscuro'}
                  leftIcon={<MdOutlineOpenInNew />}
                  onClick={() => onAbrirSolicitacao(ultimaEntrada)}
                >
                  Ver solicitações
                </ButtonCmp>
              )}

              {mostrarHistorico && (
                <ButtonCmp
                  small
                  OutlineColor={'c7'}
                  leftIcon={<FaHistory />}
                  onClick={onAlternarHistorico}
                >
                  Histórico de ajustes ({historico.length})
                </ButtonCmp>
              )}

              {status === 2 && (
                <ButtonCmp
                  small
                  OutlineColor={'Green2'}
                  leftIcon={<FaFilePdf />}
                  isLoading={baixandoPdf}
                  onClick={onBaixarPdf}
                >
                  Baixar PDF
                </ButtonCmp>
              )}

              {status !== 2 && (
                <ElementoTooltipCmp
                  label={status === 1 ? 'Resolva as solicitações de ajuste pendentes antes de reenviar' : ''}
                >
                  <ButtonCmp small OutlineColor={'Azul'} leftIcon={<FaRegPaperPlane />} isDisabled={status === 1} onClick={onReenviar}>
                    Reenviar
                  </ButtonCmp>
                </ElementoTooltipCmp>
              )}

              <ButtonCmp small OutlineColor={'Red'} leftIcon={<FaRegTrashAlt />} onClick={onExcluir}>
                Excluir
              </ButtonCmp>
            </Flex>
          </Flex>
        </Flex>

        {historicoAberto && temHistorico && (
          <HistoricoAjustes entradas={historico} onAbrir={onAbrirSolicitacao} />
        )}
      </Box>
    </Box>
  )
}
